import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-247b61d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5 table-hover" }
const _hoisted_7 = { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "badge text-bg-warning me-1"
}

import { ref, onMounted } from "vue";
import CreateItem from "../components/shop/CreateItem.vue";
import EditItem from "../components/shop/EditItem.vue";
import EventsServices from "../services/EventsServices";
import {
  EventShopItemStatusTypes,
  EventShopItemTypes,
  EventItemTypes,
  allOPtions,
} from "@/core/types/shop/ShopItemTypes";
import { ElNotification } from "element-plus";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import i18n from "@/core/plugins/i18n";
import { getLanguage } from "@/core/types/LanguageTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopInventory',
  setup(__props) {

const t = i18n.global.t;
const isLoading = ref(false);
const createRef = ref<InstanceType<typeof CreateItem>>();
const editRef = ref<InstanceType<typeof EditItem>>();
const data = ref(<any>[]);
const categoryData = ref(<any>[]);
const accountSelected = ref(0);
const eventOptions = ref(<any>[]);
const criteria = ref<any>({
  page: 1,
  pageSize: 10,
  status: null,
  sortField: "createdOn",
  sortFlag: true,
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await EventsServices.getShopItemList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const fetchCategoryData = async () => {
  try {
    const res = await EventsServices.queryShopCategoryList();
    categoryData.value = res;
  } catch (error) {
    console.log(error);
  }
};

const publishToggle = async (item: any) => {
  try {
    if (item.status == EventShopItemStatusTypes.Published) {
      await EventsServices.publishItem(item.id);
      ElNotification({
        title: "Success",
        message: t("tip.itemPublished"),
        type: "success",
      });
    } else {
      await EventsServices.unpublishItem(item.id);
      ElNotification({
        title: "Success",
        message: t("tip.itemUnpublished"),
        type: "success",
      });
    }
  } catch (error) {
    console.log(error);
    ElNotification({
      title: "Error",
      message: t("error.failedToUpdate"),
      type: "error",
    });
  }
};
const fetchEventsData = async () => {
  isLoading.value = true;
  const res = await EventsServices.queryEventsList();
  eventOptions.value = res.data;
  isLoading.value = false;
};
const create = () => {
  createRef.value?.show(eventOptions.value);
};

const edit = (item: any) => {
  editRef.value?.show(item);
};
const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

const getCategoryName = (category: number) => {
  const categoryItem = Object.values(categoryData.value).find(
    (item: any) => item.value === category
  );

  if (categoryItem) {
    return categoryItem.data[getLanguage.value] || "";
  }
  return "";
};

onMounted(() => {
  fetchEventsData();
  fetchData(1);
  fetchCategoryData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_switch, {
            class: "me-4 min-w-150px",
            modelValue: criteria.value.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.status) = $event)),
            "active-value": null,
            "active-text": _unref(t)('fields.all'),
            "inactive-value": _unref(EventShopItemStatusTypes).Published,
            "inactive-text": _unref(t)('tip.published'),
            disabled: isLoading.value,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
          }, null, 8, ["modelValue", "active-text", "inactive-value", "inactive-text", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.type) = $event)),
            clearable: "",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (fetchData(1))),
            placeholder: _unref(t)('fields.type'),
            disabled: isLoading.value,
            class: "me-4"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allOPtions), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.category,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.category) = $event)),
            clearable: "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1))),
            placeholder: _unref(t)('fields.category'),
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryData.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: getCategoryName(item.value),
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.accessSite,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.accessSite) = $event)),
            clearable: "",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (fetchData(1))),
            placeholder: _unref(t)('fields.sites'),
            disabled: isLoading.value,
            class: "ms-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (create()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.addItem")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("tip.published")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.itemId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.eventId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.itemName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.points")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.category")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: item.status,
                          "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                          "active-value": _unref(EventShopItemStatusTypes).Published,
                          onClick: ($event: any) => (publishToggle(item))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "active-value", "onClick"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.eventId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.point
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, [
                        (item.type == _unref(EventShopItemTypes).Product)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              effect: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(EventItemTypes)[item.type]), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "success",
                              effect: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(EventItemTypes)[item.type]), 1)
                              ]),
                              _: 2
                            }, 1024))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(getCategoryName(item.category)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (i, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            (item.accessSites.includes(i.value))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(i.label), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          class: "me-5",
                          onClick: ($event: any) => (edit(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 10, _hoisted_11))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(CreateItem, {
      ref_key: "createRef",
      ref: createRef,
      onSubmit: _cache[9] || (_cache[9] = ($event: any) => (fetchData(1))),
      categoryData: categoryData.value,
      getCategoryName: getCategoryName
    }, null, 8, ["categoryData"]),
    _createVNode(EditItem, {
      ref_key: "editRef",
      ref: editRef,
      onSubmit: _cache[10] || (_cache[10] = ($event: any) => (fetchData(1))),
      categoryData: categoryData.value,
      getCategoryName: getCategoryName
    }, null, 8, ["categoryData"])
  ], 64))
}
}

})